"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CaretDownFill = {
  name: 'caret-down',
  theme: 'fill',
  nameWithTheme: 'caret-down-fill',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M76.3 392.3l403.1 489.1c16.9 18.9 46.5 18.9 63.4 0l405.1-489.1c24.4-27.4 5-70.8-31.7-70.8H108.1c-36.8 0-56.3 43.4-31.8 70.8z'
    },
    children: []
  }]
};
exports.default = CaretDownFill;